import { render, staticRenderFns } from "./OneNewsRead.vue?vue&type=template&id=6e9daf16&scoped=true&"
import script from "./OneNewsRead.vue?vue&type=script&lang=js&"
export * from "./OneNewsRead.vue?vue&type=script&lang=js&"
import style0 from "./OneNewsRead.vue?vue&type=style&index=0&id=6e9daf16&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e9daf16",
  null
  
)

export default component.exports